<template>
    <div class="push-notification-box" v-if="isPushNotificationAvailable">
        <div class="d-flex">
            <div class="d-flex align-items-center justify-content-between w-100">
                <div class="font-weight-bold">{{ 'Notification' | trans }}</div>
                <div class="text-muted">{{ 'Get notified when the task is done' | trans }}</div>
            </div>
            <div class="text-muted font-weight-bold"></div>
        </div>
        <div class="continue-btn-box">
            <div
                :class="[
                    emailNotify ? 'continue-btn-active' : 'continue-btn-inactive',
                    !isRegisteredUser && 'disabled',
                ]"
                @click="handleEmailNotification"
            >
                <div class="continue-btn-text"><i class="far fa-envelope"></i> {{ 'E-Mail' | trans }}</div>
            </div>
            <div :class="pushNotify ? 'continue-btn-active' : 'continue-btn-inactive'" @click="handlePushNotification">
                <div class="continue-btn-text"><i class="far fa-bell"></i> {{ 'Push Notification' | trans }}</div>
            </div>
        </div>
    </div>
</template>
<script>
import store from './../../mixins/store.mixin';
import currentJob from './../../mixins/current_job.mixin';
import { pageNotification } from '../../../../../../helper/notify';
import { translate } from '../../../../../../helper/translate';
import PushNotification from '../../util/PushNotification';
import EmailNotification from '../../util/EmailNotification';
import Analytics from '../../util/Analytics';
import { userManager } from '../../../../../../../lib-sat/user/user-manager';
import { EventBus } from '../../events/event.bus';
import { EVENT_JOB_COMPLETE } from '../../events/job.events';
import user from "../../mixins/user.mixin"
export default {
    name: 'Notify',
    props: {},
    components: {},
    mixins: [store, currentJob, user],
    data() {
        return {
            isPushNotificationAvailable: false,
            pushNotify: false,
            emailNotify: false,
            listener: false,
        };
    },
    mounted: function () {
        this.isPushNotificationAvailable = PushNotification.isAvailable();
        this.listen();
    },

    methods: {
        listen() {
            if (this.listener === true) {
                return;
            }
            this.listener = true;
            EventBus.$on(EVENT_JOB_COMPLETE, () => {
                if (this.pushNotify) {
                    PushNotification.sendNotification(translate('Your conversion is completed.'));
                }
            });
        },

        handlePushNotification() {
            this.pushNotify = PushNotification.handlePushNotification(this.currentJob);
            if (this.pushNotify === false) {
                pageNotification.warning(
                    translate(
                        'You need to allow notifications in your browser settings to get notified when your conversion is completed.'
                    )
                );
            }
            Analytics.send('result_action', 'push_notification', this.currentJob);
        },

        async handleEmailNotification() {
            //If user is unregistered, do nothing
            if (!this.isRegisteredUser) {
                return;
            }
            this.emailNotify = true;
            this.emailNotify = await EmailNotification.handleJobEmailNotification(this.currentJob.apiJob.id);
            if (this.emailNotify) {
                pageNotification.success(translate('You will be notified via e-mail.'));
            } else {
                pageNotification.warning(
                    translate('Unfortunately there was an error, therefore we are unable to notify you via e-mail.')
                );
            }
            Analytics.send('result_action', 'email_notification', this.currentJob);
        },
    },
    computed: {},
};
</script>
<style lang="scss" scoped>
.push-notification-box {
    display: flex;
    flex-direction: column;
    gap: 20px;
}
.continue-btn-box {
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.disabled {
    opacity: 0.5;
    cursor: not-allowed !important;
}

.continue-btn-active {
    display: flex;
    background: #ff1111;
    border: 1px solid #cbcbcb;
    border-radius: 4px;
    justify-content: space-between;
    padding: 10px 20px;
    align-items: center;
    cursor: disabled;

    .continue-btn-text {
        display: flex;
        gap: 10px;
        align-items: center;
        color: white;
    }
}
.continue-btn-inactive {
    display: flex;
    background: #f8f9fa;
    border: 1px solid #cbcbcb;
    border-radius: 4px;
    justify-content: space-between;
    padding: 10px 20px;
    align-items: center;
    cursor: pointer;

    .dark-mode & {
        background: #383838;
        border: 1px solid #595959;
        color: white;
        &:hover {
            background: #323232;
        }
    }

    &:hover {
        background: #f2f2f2;
    }

    .continue-btn-text {
        display: flex;
        gap: 10px;
        align-items: center;
    }
}
</style>
